import { render } from "./InviteConfirmation.vue?vue&type=template&id=29644818&ts=true"
import script from "./InviteConfirmation.vue?vue&type=script&lang=ts"
export * from "./InviteConfirmation.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__